import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { createContext, useEffect, useRef, useState } from 'react';
const NotificationContext = createContext({});
export const Notification = ({ useTailwindPrefix, isVisible, children, linkUrl, onClose, onClick, containerClassName, className, buttonClassName, position = 'top-right', }) => {
    const [visible, setVisible] = useState(isVisible);
    const containerRef = useRef(null);
    const didMountRef = useRef(false);
    useEffect(() => {
        var _a;
        if (isVisible) {
            setTimeout(() => {
                setVisible(true);
            }, 100);
            (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('display', 'block');
            didMountRef.current = true;
        }
        else if (didMountRef.current && !isVisible) {
            setVisible(false);
            setTimeout(() => {
                var _a;
                (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('display', 'none');
            }, 300);
        }
    }, [isVisible]);
    function onCloseEvent(event) {
        event.stopPropagation();
        onClose();
    }
    return (_jsx(NotificationContext.Provider, Object.assign({ value: { useTailwindPrefix } }, { children: _jsx("div", Object.assign({ ref: containerRef, className: classNames(containerClassName, {
                'hidden fixed': !useTailwindPrefix,
                'tw-hidden tw-fixed': useTailwindPrefix,
                'top-0 left-0': position === 'top-left' && !useTailwindPrefix,
                'tw-top-0 tw-left-0': position === 'top-left' && useTailwindPrefix,
                'top-0 right-0': position === 'top-right' && !useTailwindPrefix,
                'tw-top-0 tw-right-0': position === 'top-right' && useTailwindPrefix,
                'bottom-0 left-0': position === 'bottom-left' && !useTailwindPrefix,
                'tw-bottom-0 tw-left-0': position === 'bottom-left' && useTailwindPrefix,
                'bottom-0 right-0': position === 'bottom-right' && !useTailwindPrefix,
                'tw-bottom-0 tw-right-0': position === 'bottom-right' && useTailwindPrefix,
            }) }, { children: _jsxs("div", Object.assign({ className: classNames(className, Object.assign(Object.assign({ 'bg-alerts-notification-background text-alerts-notification-a11y rounded shadow m-4 transition ease-in max-w-[320px] relative min-w-[200px] text-[14px]': !useTailwindPrefix, 'tw-bg-alerts-notification-background tw-text-alerts-notification-a11y tw-rounded tw-shadow tw-m-4 tw-transition tw-ease-in tw-max-w-[320px] tw-relative tw-min-w-[200px] tw-text-[14px]': useTailwindPrefix }, ((position === 'top-left' || position === 'bottom-left') && {
                    'translate-x-0 opacity-100': visible && !useTailwindPrefix,
                    'tw-translate-x-0 tw-opacity-100': visible && useTailwindPrefix,
                    '-translate-x-full opacity-0': !visible && !useTailwindPrefix,
                    'tw--translate-x-full tw-opacity-0': !visible && useTailwindPrefix,
                })), ((position === 'top-right' || position === 'bottom-right') && {
                    'translate-x-0 opacity-100': visible && !useTailwindPrefix,
                    'tw-translate-x-0 tw-opacity-100': visible && useTailwindPrefix,
                    'translate-x-full opacity-0': !visible && !useTailwindPrefix,
                    'tw-translate-x-full tw-opacity-0': !visible && useTailwindPrefix,
                }))) }, { children: [_jsx("div", Object.assign({ className: classNames(buttonClassName, {
                            'absolute top-0 right-0 z-10 w-6 h-6 rounded-full flex items-center justify-center transition cursor-pointer': !useTailwindPrefix,
                            'tw-absolute tw-top-0 tw-right-0 tw-z-10 tw-w-6 tw-h-6 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-transition tw-cursor-pointer': useTailwindPrefix,
                        }), onClick: onCloseEvent }, { children: _jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960", className: classNames({ 'h-4 w-4': !useTailwindPrefix, 'tw-h-4 tw-w-4': useTailwindPrefix }), fill: "currentColor" }, { children: _jsx("path", { d: "m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" }) })) })), React.createElement(linkUrl ? 'a' : 'div', Object.assign(Object.assign({ children }, (linkUrl
                        ? { href: linkUrl, target: '_blank', rel: 'noopener noreferrer' }
                        : {
                            onClick,
                        })), { className: classNames({
                            'w-full p-3 block': !useTailwindPrefix,
                            'tw-w-full tw-p-3 tw-block': useTailwindPrefix,
                            'cursor-pointer': (linkUrl || onClick) && !useTailwindPrefix,
                            'tw-cursor-pointer': (linkUrl || onClick) && useTailwindPrefix,
                        }) }))] })) })) })));
};
export default Notification;
